class AdvData {
    constructor(guid = '', src = '', link = '', name = '') {
        this.guid = guid;
        this.type = 'adv';
        this.src = src;
        this.link = link;
        this.name = name;
    }
}

export default AdvData;



// WEBPACK FOOTER //
// ./src/script/baseData/adv/advData.js